module.exports = __webpack_public_path__ + "static/conference-app.7e20e4d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Features/conference-app.jpg
// module id = 332
// module chunks = 221374088121123